import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';
import ChangeStatusShopDialogConfirm from './ChangeStatusShopDialogConfirm';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    openChange,
    updateOpenChange,
    openChangeConfirm,
    updateOpenChangeConfirm,
    cancelAction,
    changeAction,
    statusShop,
    setStatusShop,
    disableStatus,
    message,
    setMessage,
    canOpen
  }) => {
    const changeActionConfirm = () => {
      updateOpenChangeConfirm(true);
      if (statusShop === 'PRE_AVAILABLE') {
        setMessage('開店状況を【準備中】に変更します。よろしいでしょうか');
      } else if (statusShop === 'SUSPENDED') {
        setMessage('開店状況を【利用停止中】に変更します。よろしいでしょうか');
      } else if (statusShop === 'CLOSED') {
        setMessage('開店状況を【閉店】に変更します。よろしいでしょうか');
      } else if (statusShop === 'AVAILABLE') {
        setMessage('開店状況を【開店】に変更します。よろしいでしょうか');
      }
    };
    const cancelActionConfirm = () => {
      updateOpenChangeConfirm(false);
    };
    const updateStatusShop = value => {
      setStatusShop(value);
    };
    return (
      <Dialog
        open={openChange}
        onClose={() => {
          updateOpenChange(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Typography component="p" className={classes.description}>
            開店状況を変更します。
          </Typography>
          <RadioGroup
            value={statusShop}
            onChange={e => {
              updateStatusShop(e.target.value);
            }}
          >
            {canOpen && (
              <div>
                <FormControlLabel
                  value="AVAILABLE"
                  control={<Radio color="primary" disabled={disableStatus} />}
                  label="開店"
                />
              </div>
            )}

            <div>
              <FormControlLabel
                value="PRE_AVAILABLE"
                control={<Radio color="primary" disabled={disableStatus} />}
                label="準備中"
              />
            </div>
            <div>
              <FormControlLabel
                value="SUSPENDED"
                control={<Radio color="primary" disabled={disableStatus} />}
                label="利用停止中"
              />
            </div>
            <div>
              <FormControlLabel
                value="CLOSED"
                control={<Radio color="primary" disabled={disableStatus} />}
                label="閉店"
              />
            </div>
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <ChangeButton
            onClickAction={changeActionConfirm}
            enabled={!disableStatus}
          />
        </DialogActions>
        <ChangeStatusShopDialogConfirm
          message={message}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
          cancelAction={cancelActionConfirm}
          changeAction={changeAction}
        />
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
